export const manifest = {
  screens: {
    scr_m1uj22: { name: "Hero", route: "/", state: {"step":"hero"}, position: {"x":2328,"y":350} },
    scr_0n0ck9: { name: "Quiz", route: "/", state: {"step":"quiz"}, position: {"x":3728,"y":350} },
    scr_dk55xd: { name: "Loading", route: "/", state: {"step":"loading"}, position: {"x":5128,"y":350} },
    scr_sporf2: { name: "Resultado", route: "/", state: {"step":"result"}, position: {"x":6528,"y":350} },
    scr_wqbqpa: { name: "Venta", route: "/", state: {"step":"sales"}, position: {"x":7928,"y":350} },
  },
  sections: {
    sec_n2o9k4: { name: "Quiz Sales Funnel", x: 2168, y: 130, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_n2o9k4", children: [
      { kind: "screen", id: "scr_m1uj22" },
      { kind: "screen", id: "scr_0n0ck9" },
      { kind: "screen", id: "scr_dk55xd" },
      { kind: "screen", id: "scr_sporf2" },
      { kind: "screen", id: "scr_wqbqpa" },
    ] },
  ],
}
